import {
    RequestConfigFunction,
    RequestForDomainForm,
    SelectorConfig,
} from 'app/types/request.types'
import {
    WithId,
} from 'app/types/common.types'

import {
    DeploymentRequestResponse,
} from './Deployment.types'

type GatewayDeploymentRequests = {
    domainName: string,
    filterRequest: RequestConfigFunction<
        { params?: Record<string, any> },
        DeploymentRequestResponse[]
    >,
    get: RequestConfigFunction<WithId<number>, DeploymentRequestResponse>,
    update: RequestForDomainForm<WithId<number>>,
    create: RequestForDomainForm<undefined>,
    archive: RequestConfigFunction<WithId<number>>,
    restore: RequestConfigFunction<WithId<number>>,
}

const gatewayDeploymentRequests: GatewayDeploymentRequests = {
    domainName: 'Deployment',
    filterRequest: (data) => {
        return {
            url: 'gateway/deployment/filter-request/all',
            method: 'POST',
            data,
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `gateway/deployment/${id}`,
            method: 'GET',
        }
    },
    update: {
        name: 'Deployment',
        request: ({
            id,
        }) => {
            return {
                url: `gateway/deployment/${id}`,
                method: 'PUT',
                domainName: 'Deployment',
            }
        },
    },
    create: {
        name: 'Deployment',
        request: () => {
            return {
                url: 'gateway/deployment',
                method: 'POST',
                domainName: 'Deployment',
            }
        },
    },
    archive: ({
        id,
    }) => {
        return {
            url: `gateway/deployment/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `gateway/deployment/${id}/restore`,
            method: 'PATCH',
        }
    },
}

export const deploymentSelectionConfig: SelectorConfig<DeploymentRequestResponse[]> = {
    url: gatewayDeploymentRequests.filterRequest().url,
    convertion: (data) => {
        return data.map(({
            id, deploymentName,
        }) => {
            return {
                id,
                label: deploymentName,
                value: id,
            }
        })
    },
}
export default gatewayDeploymentRequests
